import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';


export default function Navbar(props) {


  return (
    <section>
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          {props.title}
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link active" aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                About
              </Link>
            </li>        
          </ul>
          <form className="d-flex">
          <div className="form-check form-switch">
          <input
              className="form-check-input"
              type="checkbox"
              id="darkmodebox"
              onClick={props.func}
            />
            <label
              className="form-check-label text-light"
              htmlFor="flexSwitchCheckDefault"
            >
              {props.btn}
            </label>
            </div>
          </form>
        </div>
      </div>
    </nav>
   </section>
  );
}

Navbar.propTypes=
{
    title: PropTypes.string.isRequired
}


Navbar.defaultProps=
{
    title:"HoomanProduction"
}